/**
 * Extracts the  numerical index from a Yup validation path.
 * This function is designed to make error messages more user-friendly by
 * identifying which item in an array has a validation error.
 *
 * @param {string} path - The validation path provided by Yup's `this.path`.
 *   For example: "selectedMilestones[1].product.name".
 * @returns {number | string} The human-readable index (1-based) of the milestone,
 *   or an empty string if no index is found.
 *
 * @example
 * // If this.path is "selectedMilestones[0].subtotal"
 * const index = getErrorIndex(this.path); // Returns 1
 *
 * // The regex /\[(\d+)\]/ finds the first number inside square brackets.
 * // parseInt(match[1], 10) converts the captured string "0" to the number 0.
 * // We add +1 because array indices are 0-based, but we want to show a 1-based index to the user.
 */
export const getErrorIndex = (path: string): number | string => {
  const match = path.match(/\[(\d+)\]/);
  const index = match ? parseInt(match[1], 10) + 1 : '';
  return index;
};
